import React, {useCallback, useState} from "react";
import {useDropzone} from "react-dropzone";
import {Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {documentService} from "../../services";
import "./addDocumentDialog.css";

const AddFileDialog = (props) => {
    const { snackbar, userId, onCancel, onSave } = props;
    const [ file, setFile ] = useState(null);
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        const success = (saved) => {
            snackbar.setSuccess(saved.fileName + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        setSaving(true);
        documentService.uploadFile(file, userId, null, null, success, failure);
    };

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles.length === 1) {
            const file = acceptedFiles[0];

            setFile(file);
        }
    }, []);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop: onDrop,
        maxFiles: 1,
    });

    return <Dialog
        open={true}
        aria-labelledby="add-document-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add File
        </ClosableDialogTitle>
        <DialogContent className="add-document-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <>
                    {file ?
                        <div className="file">
                            <Chip label={file.path} variant="outlined" onDelete={() => setFile(null)} />
                        </div> :
                        <div {...getRootProps()} className="dnd-file">
                            <input {...getInputProps()} />
                            {isDragActive ?
                                <p>Drop the file here</p> :
                                <><p>Drag & drop a file here,</p><p>or click to select</p></>}
                        </div>}
                </>}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button
                color="primary"
                disabled={!file}
                onClick={submitForm}
            >
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default AddFileDialog;
